
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";


export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchdocdatasuccess = (docview:any)=>({
    type : 'fetch_view_data_success',
    payload:docview,
});
export const fetchdeldatasuccess = (deletedata:any)=>({
    type : 'fetch_delete_data_success',
    payload:deletedata,
});
export const fetchadddatasuccess = (adddocdata:any)=>({
    type : 'fetch_add_data_success',
    payload:adddocdata,
});
export const fetchadddatasuccessfile = (imagedata:any)=>({
    type : 'fetch_add_data_success_file',
    payload:imagedata,
});
export const fetcheditdatares = (editdata:any)=>({
    type : 'fetch_edit_data_success_',
    payload:editdata,
});

export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,q:5};
            const apiname = orgapi.orgdocuments;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const viewdocdata = (DocID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {did:DocID,q:4};
            const apiname = orgapi.orgdocview;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdocdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const deletedocdata = (DocID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {did:DocID,q:3};
            const apiname = orgapi.orgdeldata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdeldatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const adddata = (document:any,date:any,adddatafile:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {document:document,date1:date,filename:adddatafile,uid:uid};
            const apiname = orgapi.orgadddoc;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchadddatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = orgapi.orgaddfile;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(fetchadddatasuccessfile(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const doceditdata = (doc_name:any,expiry_date:any,adddatafile:any,id:any,UserID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {title:doc_name,edate:expiry_date,filename:adddatafile,did:id,q:1,uid:UserID};
            const apiname = orgapi.orgdeldata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetcheditdatares(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const doceditdatanoimage = (doc_name:any,expiry_date:any,id:any,UserID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {title:doc_name,edate:expiry_date,did:id,q:1,uid:UserID};
            const apiname = orgapi.orgdeldata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetcheditdatares(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};


